import React from "react";
import "./ProfileSkeleton.css";

export const SkeletonProfileForm = () => (
  <div className="skeleton-profile-form">
    <div className="skeleton-profile-header">
      <div className="skeleton-avatar"></div>
      <div className="skeleton-title"></div>
      <div className="skeleton-subtitle"></div>
    </div>
    <div className="skeleton-profile-content">
      <div className="skeleton-field">
        <div className="skeleton-label"></div>
        <div className="skeleton-input"></div>
      </div>
      <div className="skeleton-field">
        <div className="skeleton-label"></div>
        <div className="skeleton-input"></div>
      </div>
      <div className="skeleton-field">
        <div className="skeleton-label"></div>
        <div className="skeleton-input"></div>
      </div>
      <div className="skeleton-field">
        <div className="skeleton-label"></div>
        <div className="skeleton-input"></div>
      </div>
      <div className="skeleton-field">
        <div className="skeleton-label"></div>
        <div className="skeleton-input"></div>
      </div>
      <div className="skeleton-field">
        <div className="skeleton-label"></div>
        <div className="skeleton-input"></div>
      </div>
      <div className="skeleton-btn"></div>
    </div>
  </div>
);
